/* eslint-disable react/prop-types */
import React from 'react'
import { useSvg } from 'irmlib/hooks'

/**
 * @function
 * @description AccountCircle
 * @param {object} props props.
 * @param {string} props.fill Fill color for the icon. By default, it picks up the color of the nearest parent.
 * @param {number} props.scale Scale for the size of the icon. The default is 1.
 * @returns {object} svg of the icon
 */
export default props => {
  const viewBoxWidth = 37.926
  const viewBoxHeight = 36.002
  const [fill, width, height] = useSvg(props, viewBoxWidth, viewBoxHeight)
  return (
    <svg width={width} height={height} viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <path id="Path_account-circle" data-name="Path / account-circle" d="M20.963,32.962A13.921,13.921,0,0,1,9.585,27.2c.057-3.6,7.585-5.58,11.378-5.58S32.284,23.6,32.341,27.2a13.921,13.921,0,0,1-11.378,5.76m0-25.562a5.55,5.55,0,0,1,5.689,5.4,5.55,5.55,0,0,1-5.689,5.4,5.55,5.55,0,0,1-5.689-5.4,5.55,5.55,0,0,1,5.689-5.4m0-5.4C10.49,2,2,10.059,2,20s8.49,18,18.963,18,18.963-8.059,18.963-18S31.393,2,20.963,2Z" transform="translate(-2 -2)" fill={fill}/>
    </svg>
  )
}
